var styles = {"article":"StickyHeaderArea-module_article__hVjGg","scroll-border":"StickyHeaderArea-module_scroll-border__BWd43","line-tab":"StickyHeaderArea-module_line-tab__8Xa8l","line-tab-scroll-down":"StickyHeaderArea-module_line-tab-scroll-down__i0BU5","line-tab-scroll-up":"StickyHeaderArea-module_line-tab-scroll-up__Q5ELd"};

export { styles as default };
